import { Action, createReducer, on } from '@ngrx/store';
import { IGlimpseReport } from 'src/app/modules/customer-shared/models/IGlimpseReport';
import { PosCategorySop } from "src/app/modules/customer-shared/models/PosCategorySop";
import { IAreaDate } from 'src/app/modules/report-components/models/IAreaDate';
import * as actions from './report.actions';
import { reportId } from '../_utils/report.utils';
import { logout } from '../auth';
import { IAuditSales } from "../../modules/shared/models/IAuditSales";

export interface ReportPageState {
  cache: {
    [key: string]: IGlimpseReport;
  };
  sales: IAuditSales | null;
  dates: {
    [key: number]: IAreaDate[];
  };
  months: {
    [key: number]: IAreaDate[];
  };
  report: IGlimpseReport | null;
  posCategorySopDialog: {
    categories: PosCategorySop[];
    loading: boolean;
    updating: boolean;
  };
  loading: boolean;
  error: string | null;
}

export const initialReportPageState: ReportPageState = {
  cache: {},
  dates: {},
  months: {},
  report: null,
  sales: null,
  posCategorySopDialog: {
    categories: [],
    loading: false,
    updating: false,
  },
  loading: false,
  error: null,
};

const reducer = createReducer(
  initialReportPageState,
  on(actions.loadReport, (state, action) => ({
    ...state,
    loading: true,
    error: null as string | null,
    report: action.hydrateWith,
  })),
  on(actions.setCurrentReport, (state, action) => {
    const newState: ReportPageState = {
      ...state,
      report: action.report,
      loading: false,
      error: null,
    };
    if (action.cache) {
      newState.cache = {
        ...newState.cache,
        [reportId(action.report.areaId, action.report.periodId)]: action.report,
      };
    }
    return newState;
  }),
  on(actions.reportLoadError, (state, { error }) => ({
    ...state,
    error,
    loading: false,
    report: null as IGlimpseReport | null,
  })),
  on(actions.setAreaDates, (state, action) => ({
    ...state,
    dates: {
      ...state.dates,
      [action.areaId]: action.dates,
    },
  })),
  on(actions.setAreaMonths, (state, action) => ({
    ...state,
    months: {
      ...state.months,
      [action.areaId]: action.months,
    },
  })),
  on(logout, state => ({
    ...initialReportPageState,
  })),
  on(actions.loadPosCategorySop, state => ({
    ...state,
    posCategorySopDialog: { ...state.posCategorySopDialog, loading: true, categories: [] as PosCategorySop[] },
  })),
  on(actions.loadPosCategorySopSuccess, (state, { sop }) => ({
    ...state,
    posCategorySopDialog: { ...state.posCategorySopDialog, loading: false, categories: sop },
  })),
  on(actions.loadPosCategorySopFail, (state, { error }) => ({
    ...state,
    posCategorySopDialog: { ...state.posCategorySopDialog, loading: false },
  })),
  on(actions.updatePosCategorySop, state => ({
    ...state,
    posCategorySopDialog: { ...state.posCategorySopDialog, updating: true },
  })),
  on(actions.updatePosCategorySopSuccess, state => ({
    ...state,
    posCategorySopDialog: { ...state.posCategorySopDialog, updating: false, categories: [] as PosCategorySop[] },
  })),
  on(actions.updatePosCategorySopFail, state => ({
    ...state,
    posCategorySopDialog: { ...state.posCategorySopDialog, updating: false, categories: [] as PosCategorySop[] },
  })),
  on(actions.loadAuditSalesSuccess, (state, { sales }) => ({
    ...state,
    sales: sales,
  })),
  on(actions.loadAuditSalesFail, (state, error) => ({
    ...state,
    error: error.message,
  })),
);

export function reportPageReducer(state: ReportPageState | undefined, action: Action) {
  return reducer(state, action);
}

///////////
